(ns app.query.filter-util
  (:require [clojure.tools.reader.edn :as edn]))

(defn valid-date-range-values?
  "Whether values contain one non-empty, ordered range of instant bounds."
  [values]
  (and (set? values)
       (= 1 (count values))
       (let [{:keys [from to] :as value} (first values)]
         (and (map? value)
              (seq value)
              (every? #{:from :to} (keys value))
              (every? inst? (vals value))
              (or (nil? from)
                  (nil? to)
                  (<= (inst-ms from) (inst-ms to)))))))


(defn filter-entity->search-values-map [filter]
  (->> filter
       :filter/conditions
       (reduce (fn [acc {:filter.condition/keys [attribute values]}]
                 (assoc acc attribute (if (string? values)
                                        (edn/read-string values)
                                        values)))
               {})))
